<div class="component-container">
  @let title = config().title;
  @if (title.type === TitleType.IMAGE) {
    <img
      class="title-image"
      [src]="title.picture.imageUrl"
      [alt]="title.picture.alternativeText"
    />
  } @else {
    <div
      class="title"
      [style]="{
        color: title.color,
        fontFamily: title.fontFamily,
      }"
    >
      {{ title.text }}
    </div>
  }

  @let subtitle = config().subtitle;
  @if (subtitle) {
    <div
      class="subtitle"
      [style]="{
        color: subtitle.color,
        fontFamily: subtitle.fontFamily,
      }"
    >
      {{ subtitle.text }}
    </div>
  }

  <div class="contact-block">
    <div class="form-field">
      <form [formGroup]="form" class="form-wrapper">
        @for (item of config().contactFormBlock.fields; track $index) {
          @switch (item.type) {
            <!-- Email|Text|Number|Password -->
            @case (
              FormFieldType.EMAIL ||
              FormFieldType.TEXT ||
              FormFieldType.NUMBER ||
              FormFieldType.PASSWORD
            ) {
              <b2c-input
                [type]="item.type"
                [errorStyles]="item.errorStyles!"
                [placeholder]="item.placeholder"
                [attr.data-cy]="item.formControlName"
                [formControlName]="item.formControlName"
                [errorMessages]="controlErrorMessages[item.formControlName]"
                [autoComplete]="item.autoComplete || ''"
                [required]="item.required || false"
              />
            }
            <!-- Email|Text|Number|Password -->

            <!-- TextArea -->
            @case (FormFieldType.TEXTAREA) {
              <b2c-text-area
                class="message-field"
                [type]="item.type"
                ngSkipHydration
                [placeholder]="item.placeholder"
                [attr.data-cy]="item.formControlName"
                [formControlName]="item.formControlName"
                [errorMessages]="controlErrorMessages[item.formControlName]"
              />
            }
            <!-- TextArea -->

            @default {
              <b2c-input
                [type]="item.type"
                [inputTypeGroup]="false"
                [placeholder]="item.placeholder"
                [attr.data-cy]="item.formControlName"
                [formControlName]="item.formControlName"
                [errorMessages]="controlErrorMessages[item.formControlName]"
              />
            }
          }
        }

        <b2c-button
          class="submit-btn"
          (click)="submit()"
          buttonType="submit"
          [styles]="{
            backgroundColor:
              config().contactFormBlock.submitButton.backgroundColor,
            color: config().contactFormBlock.submitButton.color,
            fontFamily: config().contactFormBlock.submitButton.fontFamily,
            borderRadius: '100px',
            border: 'none',
            padding: '10px 20px',
          }"
          [class.disabled]="form.invalid || submitted()"
        >
          {{ config().contactFormBlock.submitButton.label }}
        </b2c-button>
      </form>
    </div>
  </div>
</div>
